export default __webpack_public_path__ + "static/media/project1image1.032ad45a.png";